import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit {

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-details/contact-details.component.ts